import React from 'react'
import styled from '@emotion/styled'
import { Paragraph, Header, Icon, Button } from 'components/patterns'
import { CollapsibleWidget, ChecTable } from 'components/chec'
import { stylesIf } from 'utils/styles'

export const StyledCollapsibleWidget = styled(CollapsibleWidget)(
  (props) => `
    && {
      border: 0px;

      .collapsible-widget_header {
        background-color: transparent;
        background: transparent;
        border: 0px;
        height: 16px;
      }
      .collapsible-widget_header > div {
        display: flex;
        flex-direction: row-reverse;
        align-items: baseline;
        justify-content: inherit;
        width: 950px;
      }
    }
  `
)

export const StyledParagraph = styled(Paragraph)`
  margin-top: 16px;
  margin-bottom: 5px;
`

export const ListHeaderAndIcon = styled.div((props) => {
  const { index, groupLength } = props

  const { sAndGListHeaderIconBorderColor } = props.theme
  const indexCheck = index > 0
  const groupNotZero = groupLength !== 0

  return `
    display: flex;
    flex-direction: row;
    ${stylesIf(
      indexCheck,
      `
      border-top: 1px solid ${sAndGListHeaderIconBorderColor};`
    )}
    ${stylesIf(
      groupNotZero,
      `
      padding-top: 7px;`
    )}
  `
})

export const Group = styled.div`
  margin: 0;
`
export const ListHeader = (props) => <StyledListHeader {...props} type="h3" />

const StyledListHeader = styled(Header)`
  font-size: 18px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  padding-top: 10px;
`

export const SectionHeader = styled(Header)((props) => {
  const { paragraphColor } = props.theme

  return `
    color: ${paragraphColor};
    font-size: 12px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.33;
    letter-spacing: normal;
  `
})

export const StyledInfoIcon = styled(Icon)((props) => {
  const { blueAccent } = props.theme

  return `
    :hover {
      color: ${blueAccent};
    }
  `
})

export const StyledPanelNumberColumn = styled.span`
  white-space: nowrap;
`
export const StyledTableButton = styled(Button)`
  width: 242px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
  display: block;
`

export const StyledEmpty = styled.span`
  width: 242px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
  display: block;
`

export const StyledChecTable = styled(ChecTable)((props) => {
  const { sAndGTableHeaderFillColor } = props.theme

  return `
    .ant-table {
      border-color: transparent; 
    }
    .ant-table-small {
      border-color: transparent; 
    }
    .chec-table-row > td {
      padding: 2px 8px !important;
      border-color: 1px solid transparent !important;
    }
    .ant-table-tbody > tr > td {
      border-bottom: 1px solid transparent;
    }
    .chec-table td, .chec-table th {
      padding: 5px 8px !important;
    }
    .chec-table-row {
      height: 3px;
    }
    thead.ant-table-thead {
      background-color: ${sAndGTableHeaderFillColor};
      height: 3px;
      padding: 5px 8px !important;
    }
    th {
      border-right: 0.5px solid white !important
    }
  `
})

export const UnAssignedPartHeaderIcon = styled(Icon)`
  display: inline;
  margin-right: 8px;
`

export const UnAssignedPartHeader = styled.h3`
  font-weight: bold;
  display: inline;
`

export const UnassignedComponentTable = styled.div((props) => {
  const { sAndGListHeaderIconBorderColor } = props.theme

  return `
    border-bottom: 1px solid ${sAndGListHeaderIconBorderColor};
    padding-top: 7px;
    margin-bottom: 7px;
  `
})
